<template>
    <v-timeline align-top dense>
        <div class="timeline-wrap" v-for="(item, index) in items" :key="index">
            <v-timeline-item v-if="item.step === step" color="pink" small class="current"><p>{{ item.title }}</p></v-timeline-item>
            <v-timeline-item v-else-if="item.step > step" color="grey"  class="after" small><p>{{ item.title }}</p></v-timeline-item>
            <v-timeline-item v-else color="pink" small><p>{{ item.title }}</p></v-timeline-item>
        </div>
    </v-timeline>
</template>

<script>
    export default {
        props: ['step'],
        data: () => ({
            items: [
                { step: 1, title: '1.契約書・書類の選択' },
                { step: 2, title: '2.書類のタイトル入力' },
                { step: 3, title: '3.送付先の入力' },
                { step: 4, title: '4.書類の入力項目を設定' },
                { step: 5, title: '5.送信内容確認'},
            ],
        }),
    };
</script>
